module.exports = __webpack_public_path__ + "img/fwlcImg2.682cf844.png";